import { render, staticRenderFns } from "./lessonStats.vue?vue&type=template&id=23cc6806&lang=html&"
import script from "./lessonStats.vue?vue&type=script&lang=ts&"
export * from "./lessonStats.vue?vue&type=script&lang=ts&"
import style0 from "./lessonStats.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports